<!-- <div class="promotion-page container-fluid py-4"> -->
<div>
  <div class="page-heading d-flex flex-wrap align-items-start justify-content-between gap-3 mb-4">
    <div>
      <!-- <div class="eyebrow">ACADEMIC MANAGEMENT</div> -->
      <h1 class="h3 mb-1">Student Migration &amp; Promotion</h1>
      <p class="text-muted mb-0">Review students, assign the next class, and process year-end promotions.</p>
    </div>
    <span class="academic-year"><i class="bi bi-calendar3 me-2"></i>Academic Year {{acd_session}}</span>
  </div>

  <!-- <div class="row g-3 mb-4">
    <div class="col-12 col-md-4">
      <div class="metric-card">
        <div class="metric-icon icon-blue"><i class="bi bi-people"></i></div>
        <div><div class="metric-label">Students in source class</div><div class="metric-value">{{ sourceStudents.length }}</div></div>
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="metric-card">
        <div class="metric-icon icon-green"><i class="bi bi-check2-circle"></i></div>
        <div><div class="metric-label">Passed students</div><div class="metric-value">{{ passedCount }}</div></div>
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="metric-card">
        <div class="metric-icon icon-amber"><i class="bi bi-hourglass-split"></i></div>
        <div><div class="metric-label">Awaiting action</div><div class="metric-value">{{ pendingCount }}</div></div>
      </div>
    </div>
  </div>

  <section class="panel mb-4">
    <div class="panel-heading">
      <div>
        <h2 class="h6 mb-1">Promotion setup</h2>
        <p class="small text-muted mb-0">Choose the current class to load its student list.</p>
      </div>
      <span class="step-badge">Step 1 of 2</span>
    </div>
    <div class="row g-3 align-items-end">
      <div class="col-12 col-md-5">
        <label for="source_class" class="form-label">Source class <span class="text-danger">*</span></label>
        <select id="source_class" class="form-select" [(ngModel)]="source_class" (ngModelChange)="onSourceClassChange()">
          <option *ngFor="let className of classes" [value]="className">{{ className }}</option>
        </select>
      </div>
      <div class="col-12 col-md-7">
        <div class="info-note"><i class="bi bi-info-circle me-2"></i>Target classes are restricted to classes above the selected source class.</div>
      </div>
    </div>
  </section> -->

  <section class="panel">
    <div class="panel-heading flex-wrap">
      <div>
        <h2 class="h6 mb-1">Student List <span class="count-badge">#{{ filteredStudents.length }}</span></h2>
        <p class="small text-muted mb-0">Set each student's result and target class before promotion.</p>
      </div>
      <div class="toolbar-search">
        <!-- <i class="bi bi-search"></i>
        <input type="search" class="form-control" placeholder="Search name, admission no. or roll no." [(ngModel)]="searchText" aria-label="Search students"> -->
        <select id="source_class" class="form-select" [(ngModel)]="source_class" (ngModelChange)="onSourceClassChange()">
          <!-- <option *ngFor="let cls of classes; track cls;" [value]="cls.code">{{ cls.name }}</option> -->
          @for (c of classes; track c) { <option [ngValue]="c.code">{{ c.name }}</option> }
        </select>
      </div>
    </div>

    <div *ngIf="notice" 
      class="alert theme-{{noticeType}} py-2 mx-3 mt-3 mb-0 d-flex justify-content-between align-items-center" 
      [ngClass]="{
        'alert-success': noticeType === 'success',
        'alert-warning': noticeType === 'warning',
        'alert-info': noticeType === 'info'
      }" role="alert">
      {{ notice }}
      <button type="button" class="btn-close ms-auto p-1" style="font-size: 10px;"
        data-bs-dismiss="alert" aria-label="Close"></button>
    </div>

    <div class="filter-row d-flex flex-wrap align-items-center gap-2">
      <label for="resultFilter" class="small text-muted mb-0">Show result:</label>
      <select id="resultFilter" class="form-select form-select-sm filter-select" [(ngModel)]="resultFilter">
        <option>All</option><option>Pass</option><option>Fail</option><option>Pending</option>
      </select>
      <span class="small text-muted ms-md-auto">#{{ selectedStudents.length }} selected</span>
    </div>

    <div class="table-responsive">
      <table class="table student-table align-middle mb-0">
        <thead>
          <tr>
            <th class="check-col"><input class="form-check-input" type="checkbox" [(ngModel)]="selectAll" (change)="toggleSelectAll()" aria-label="Select all visible students"></th>
            <th>Student</th>
            <th>Gender</th>
            <th>Roll No.</th>
            <th>Fee Due</th>
            <th>Result</th>
            <th>Target class</th>
            <th>Promotion status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let student of filteredStudents; trackBy: trackById">
            <td>
              <input class="form-check-input" type="checkbox" [(ngModel)]="student.selected" 
                (change)="syncSelectAll()" [attr.aria-label]="'Select ' + student.name"
                [disabled]="student.status=='Promoted'">
            </td>
            <td>
              <div class="student-cell">
                <div class="avatar">{{ dataService.getInitName(student.name) }}</div>
                <div><div class="student-name">{{ student.name }}</div><div class="student-meta">Adm.No.: {{ student.adm_code }}</div></div>
              </div>
            </td>
            <td>{{student.gender}}</td>
            <td>{{ student.rollNo }}</td>
            <td>{{ student.fee_due }}</td>
            <td>
              <select class="form-select form-select-sm result-select" 
                [(ngModel)]="student.result" [attr.aria-label]="'Result for ' + student.name"
                [disabled]="student.status=='Promoted'">
                <option value="Pass">Pass</option><option value="Fail">Fail</option><option value="Pending">Pending</option>
              </select>
            </td>
            <td>
              <select class="form-select form-select-sm target-select" 
                [(ngModel)]="student.target_class" [disabled]="student.result !== 'Pass'" 
                [attr.aria-label]="'Target class for ' + student.name"
                [disabled]="student.status=='Promoted'">
                <option *ngFor="let target of targetOptions" [value]="target.code">{{ target.name }}</option>
                <option *ngIf="targetOptions.length === 0" [value]="student.source_class">{{ student.source_class }} (current)</option>
              </select>
            </td>
            <td><span class="status-pill" [ngClass]="statusClass(student.status)">{{ student.status }}</span></td>
          </tr>
          <tr *ngIf="filteredStudents.length === 0">
            <td colspan="8" class="empty-state">
              <i class="bi bi-person-exclamation"></i>
              <div class="fw-semibold mt-2">No students found</div>
              <div class="small text-muted">Try another search or select a different source class.</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="action-bar d-flex flex-lg-row align-items-stretch align-items-lg-center gap-3">
      <select id="bulkTarget" #bulkTarget class="form-select" style="width: 200px;">
        <option value="">Set target for selected…</option>
        <option *ngFor="let target of targetOptions" [value]="target.code">{{ target.name }}</option>
      </select>
      <button type="button" class="btn btn-sm btn-outline-primary text-nowrap" (click)="setTargetForSelected(bulkTarget.value)">Apply to selected</button>
      <!-- <button type="button" class="btn btn-sm btn-outline-secondary" (click)="markSelectedAsFailed()"><i class="bi bi-x-circle me-1"></i>Mark as failed</button> -->
      <button type="button" class="btn btn-sm btn-primary text-nowrap ms-auto" (click)="promoteSelected()">Promote selected</button>
    </div>
    <div class="footer-hint text-danger"><i class="bi bi-shield-check me-2"></i> Review results and target classes carefully before confirming promotion.</div>
  </section>
</div>

<div class="modal-backdrop-custom" *ngIf="showConfirm" role="presentation">
  <div class="confirm-dialog" role="dialog" aria-modal="true" aria-labelledby="confirmTitle">
    <div class="confirm-icon"><i class="bi bi-arrow-up-circle"></i></div>
    <h2 id="confirmTitle" class="h5">Confirm student promotion</h2>
    <p class="text-muted">You are about to promote {{ selectedStudents.length }} selected student(s). Their promotion status will be updated in this demo.</p>
    <div class="d-flex justify-content-end gap-2 mt-4">
      <button class="btn btn-light border" type="button" (click)="showConfirm = false">Cancel</button>
      <button class="btn btn-primary" type="button" (click)="confirmPromotion()">Confirm promotion</button>
    </div>
  </div>
</div>
